import { Controller } from "stimulus";

export default class TableRowController extends Controller {
  editReason(event) {
    const form = event.target.closest("form")
    const formData = new FormData(form)

    const { reasonOther } = event.target.dataset

    fetch(form.action, {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    }).then(() => {
      if (reasonOther === formData.get('cancellation[reason_type]')) {
        this.hideRow()
      }
    })
  }

  // eslint-disable-next-line class-methods-use-this
  createCard(event) {
    const form = event.target.closest("form")

    fetch(form.action, {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: new FormData(form)
    }).then(() => {
      const element = event.target
      element.disabled = true
    })
  }

  treat(event) {
    const form = event.target.closest("form")
    const formData = new FormData(form)

    formData.set('cancellation[treated_at]', new Date().toLocaleString())

    fetch(form.action, {
      method: 'PATCH',
      body: formData
    }).then(this.hideRow.bind(this))
  }

  hideRow() {
    this.element.remove()
  }
}
